/**
 * Validation Schemas using Yup
 *
 * Centralized validation rules for forms across the application.
 * These schemas work with React Hook Form's resolver.
 */

import * as yup from 'yup';

// Checkout form validation (limits follow public API contract v1 §3.4)
export const POLICY_REQUIRED_MESSAGE =
  'Please agree to the Terms, Privacy Policy and Cancellation Policy to book.';

export const PHONE_PATTERN = /^[+\d][\d\s().-]*$/;

export const checkoutSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required('First name is required')
    .max(100, 'First name cannot exceed 100 characters'),

  lastName: yup
    .string()
    .trim()
    .required('Last name is required')
    .max(100, 'Last name cannot exceed 100 characters'),

  email: yup
    .string()
    .trim()
    .lowercase()
    .required('Email is required')
    .email('Please enter a valid email address')
    .max(254, 'Email cannot exceed 254 characters'),

  phone: yup
    .string()
    .trim()
    .max(32, 'Phone number cannot exceed 32 characters')
    .matches(PHONE_PATTERN, {
      message: 'Please enter a valid phone number',
      excludeEmptyString: true,
    }),

  notes: yup
    .string()
    .trim()
    .max(2000, 'Notes cannot exceed 2000 characters'),

  policyAccepted: yup
    .boolean()
    .required(POLICY_REQUIRED_MESSAGE)
    .oneOf([true], POLICY_REQUIRED_MESSAGE),

  // Honeypot: real visitors never see or fill it.
  website: yup.string(),
});

// Contact form validation
export const contactSchema = yup.object({
  name: yup
    .string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters')
    .trim(),

  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address')
    .max(100, 'Email cannot exceed 100 characters')
    .lowercase()
    .trim(),

  message: yup
    .string()
    .required('Message is required')
    .min(10, 'Message must be at least 10 characters')
    .max(1000, 'Message cannot exceed 1000 characters')
    .trim(),
});